import { EditorialType, ExportOptions, UserRole, User } from '../../domain/domain';

export function isEditorialTypeSelected(exportOptions: ExportOptions, editorialType: EditorialType): boolean {
    return exportOptions.editorialTypes.includes(editorialType);
}

export function setEditorialTypeSelected(
    exportOptions: ExportOptions,
    editorialType: EditorialType,
    selected: boolean
): ExportOptions {
    let newEditorialTypes = [...exportOptions.editorialTypes];

    if (selected) {
        if (!isEditorialTypeSelected(exportOptions, editorialType)) {
            newEditorialTypes.push(editorialType);
        }
    } else {
        let idx = newEditorialTypes.findIndex(type => type === editorialType);
        if (idx >= 0) {
            newEditorialTypes.splice(idx, 1);
        }
    }

    return { ...exportOptions, editorialTypes: newEditorialTypes };
}

export function getHiddenEditorialTypes(currentUser?: User): EditorialType[] {
    if (currentUser?.userRole === UserRole.NON_PUBLICATIONS_TEAM) {
        return [
            EditorialType.ANALYSIS,
            EditorialType.ANALYSIS_COMMENT,
            EditorialType.COMMENT,
            EditorialType.FORM_INDEX,
            EditorialType.INDEX
        ];
    }
    return [];
}

export function getVisibleEditorialTypes(currentUser?: User): Array<{ type: EditorialType; label: string }> {
    const allTypes = [
        { type: EditorialType.ANALYSIS, label: "Analysis" },
        { type: EditorialType.EDITORS_NOTE, label: "Editor's Note" },
        { type: EditorialType.COMMENT, label: "Comment" },
        { type: EditorialType.ANALYSIS_COMMENT, label: "Analysis Comment" },
        { type: EditorialType.FORM_INDEX, label: "Form Index" },
        { type: EditorialType.SOURCE_NOTE, label: "Source Note" },
        { type: EditorialType.CROSS_REFERENCES, label: "Cross References/Law Review" },
        { type: EditorialType.ANNOTATION, label: "Annotations" },
        { type: EditorialType.INDEX, label: "Index" }
    ];

    const hiddenTypes = getHiddenEditorialTypes(currentUser);
    if (hiddenTypes.length === 0) {
        return allTypes;
    }

    return allTypes.filter(({ type }) => !hiddenTypes.includes(type));
}

export function filterEditorialTypesByUserRole(
    exportOptions: ExportOptions,
    currentUser?: User
): ExportOptions {
    const hiddenTypes = getHiddenEditorialTypes(currentUser);
    if (hiddenTypes.length === 0) {
        return exportOptions;
    }

    const filteredTypes = exportOptions.editorialTypes.filter(
        type => !hiddenTypes.includes(type)
    );

    if (filteredTypes.length === exportOptions.editorialTypes.length) {
        return exportOptions;
    }

    return {
        ...exportOptions,
        editorialTypes: filteredTypes
    };
}